import Vue from 'vue'
import axios from 'axios'
import { SUPPORTED_LANGUAGES } from '@/constants/trans'

// state
export const state = {
  isAthleteLoading: false,
  selectedAthleteId: null,
  all: {},
}

// eslint-disable-next-line camelcase
export const processAthlete = ({ image_url, pivot, score, ...athlete }) => {
  const name = (SUPPORTED_LANGUAGES.reduce((acc, lang) => {
    if (!athlete.first_name[lang] && !athlete.last_name[lang]) {
      athlete.first_name[lang] = athlete.first_name['en']
    }
    if (!athlete.last_name[lang]) {
      athlete.last_name[lang] = athlete.last_name['en']
    }
    if (athlete.team) {
      if (!athlete.team.name[lang]) {
        athlete.team.name[lang] = athlete.team.name['en']
      }
      if (!athlete.team.display_name[lang]) {
        athlete.team.display_name[lang] = athlete.team.display_name['en']
      }
    }
    if (!athlete.first_name[lang]) athlete.first_name[lang] = ''
    if (!athlete.last_name[lang]) athlete.first_name[lang] = ''
    acc[lang] = `${athlete.first_name[lang]} ${athlete.last_name[lang]}`.trim()
    return acc
  }, {}))
  return {
    ...athlete,
    // eslint-disable-next-line camelcase
    name,
    score: score ? parseInt(score) : 0,
    lastName: athlete.last_name,
    image: image_url,
  }
}

// getters
export const getters = {
  getSelectedAthlete: ({ all, selectedAthleteId }) => all[selectedAthleteId] || [],
}
// mutations
export const mutations = {
  fetchAthleteStarted(state) {
    state.isAthleteLoading = true
  },
  fetchAthleteSuccess(state, { athlete }) {
    Vue.set(state.all, athlete.id, processAthlete(athlete))
    state.isAthleteLoading = false
  },
  fetchAthleteFailed(state) {
    state.isAthleteLoading = false
  },
  setSelectedAthlete(state, { athleteId = null } = {}) {
    state.selectedAthleteId = athleteId
  },
}
// actions
export const actions = {
  closeAthleteDetail({ commit }) {
    commit('setSelectedAthlete')
  },
  openAthleteDetail({ commit, dispatch }, { athleteId }) {
    dispatch('fetchAthlete', { athleteId })
    commit('setSelectedAthlete', { athleteId })
  },
  async fetchAthlete({ commit, state: { all } }, { athleteId }) {
    if (typeof all[athleteId] !== 'undefined') {
      return all[athleteId]
    }
    let athlete = null
    try {
      commit('fetchAthleteStarted')
      athlete = await axios.get(`athlete/${athleteId}`)
      commit('fetchAthleteSuccess', { athlete })
    } catch (e) {
      commit('fetchAthleteFailed')
    }
    return athlete
  },
}
